import type { ApiError } from '@bo-types/authentication';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useRefundNewWagerMutation } from '@bo-services/members/newWagersApi';

export const useMemberNewWagers = () => {
  const { memberId } = useParams<{ memberId?: string }>();

  const [
    refundNewWager,
    {
      error: refundError,
      isError: isRefundError,
      isLoading: isRefundLoading,
      isSuccess: isRefundSuccess,
      reset: resetRefundNewWager
    }
  ] = useRefundNewWagerMutation();

  const refundErrorMessage = (refundError as ApiError)?.data?.error;

  const handleRefundNewWager = useCallback(
    async (newWagerId: string): Promise<void> => {
      if (!memberId || !newWagerId) {
        throw new Error('Member ID and New Wager ID are required');
      }

      await refundNewWager({ memberId, newWagerId }).unwrap();
    },
    [memberId, refundNewWager]
  );

  return {
    isRefundError,
    isRefundLoading,
    isRefundSuccess,
    onRefundNewWager: handleRefundNewWager,
    refundError: refundErrorMessage,
    resetRefundNewWager
  };
};
